const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512px",
    height: "512px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.998
    },
    fill: "#007acc",
    d: "M 5.5,4.5 C 172.167,4.5 338.833,4.5 505.5,4.5C 505.5,171.5 505.5,338.5 505.5,505.5C 338.833,505.5 172.167,505.5 5.5,505.5C 5.5,338.5 5.5,171.5 5.5,4.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfefe",
    d: "M 369.5,233.5 C 379.506,233.334 389.506,233.5 399.5,234C 422.681,236.753 440.014,248.253 451.5,268.5C 440.406,277.248 428.739,285.248 416.5,292.5C 408.222,277.528 395.555,271.362 378.5,274C 366.797,278.568 362.297,287.068 365,299.5C 366.343,303.51 368.509,307.01 371.5,310C 377.178,313.841 383.178,317.174 389.5,320C 407.499,326.832 424.499,335.499 440.5,346C 462.44,364.151 470.274,387.318 464,415.5C 458.092,436.408 444.925,450.575 424.5,458C 403.494,464.224 382.16,465.224 360.5,461C 335.587,454.395 316.92,439.895 304.5,417.5C 304.977,416.522 305.643,415.689 306.5,415C 318.167,408.5 329.833,402 341.5,395.5C 348.102,406.267 357.102,414.433 368.5,420C 382.968,425.324 396.968,424.324 410.5,417C 417.815,410.382 420.315,402.216 418,392.5C 415.925,388.421 413.092,384.921 409.5,382C 391.321,372.744 372.987,363.744 354.5,355C 326.185,338.534 314.351,314.034 319,281.5C 326.595,255.737 343.429,239.737 369.5,233.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfefe",
    d: "M 115.5,235.5 C 174.167,235.5 232.833,235.5 291.5,235.5C 291.5,249.167 291.5,262.833 291.5,276.5C 269.833,276.5 248.167,276.5 226.5,276.5C 226.5,338.167 226.5,399.833 226.5,461.5C 211.167,461.5 195.833,461.5 180.5,461.5C 180.5,399.833 180.5,338.167 180.5,276.5C 158.833,276.5 137.167,276.5 115.5,276.5C 115.5,262.833 115.5,249.167 115.5,235.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTs);
export default __webpack_public_path__ + "static/media/ts.3c76373f7ad84616720ed699bc2b469f.svg";
export { ForwardRef as ReactComponent };